export const toastMessageType = {
    success: "success",
    error: "error",
    warning: "warn",
    information: "info"
}